<div appDynamicScreenHeight *ngIf="(dealsLoading$ | async) else nonLoading" class="tw-grid tw-items-center">
  <mat-spinner class="tw-m-auto" diameter="48"></mat-spinner>
</div>

<ng-template #nonLoading>

  <app-deals-table
    [readOnly]="true"
    [deals$]="deals$"
    [loading]="dealsLoading$ | async"
    [borrowerId]="borrowerId$ | async"
    [showDealRightColumn]="false"
    [showDealsPageLink]="true"
    [activeColumns]="activeColumns"
  >
  </app-deals-table>

</ng-template>
